import { useRef } from 'react';

import { useLegalClientSaveAddresses } from 'api/requests';
import { useFilesUpload, useServerErrorNotify } from 'hooks';
import { useOnboardingCountries } from 'modules/onboarding/common/hooks';

import { CompanyAddressFormType } from '../forms/companyAddressForm';
import {
  getInitialData,
  getSubmitData,
} from '../helpers/companyRegistrationAddress';

import { useOnboardingContext } from './useOnboardingContext';

export const useCompanyRegistrationAddress = () => {
  const {
    error,
    loading: submitLoading,
    saveAddresses,
  } = useLegalClientSaveAddresses();

  const { goToBack, goToNext, data } = useOnboardingContext();

  const { countries, loading: countriesLoading } = useOnboardingCountries();

  const initialData = useRef(getInitialData(data.legalClient!)).current;
  const initialValues = useRef(initialData?.values).current;

  const {
    files,
    isLoadingFile: submitDisabled,
    onRemoveFile,
    onAddFiles,
  } = useFilesUpload(initialData?.files);

  const onSubmit = async (values: CompanyAddressFormType) => {
    if (values) {
      const submitData = getSubmitData(values);
      await saveAddresses(data.legalClient!.id, submitData);
      goToNext();
    }
  };

  useServerErrorNotify(error);

  return {
    initialValues,
    countries,
    countriesLoading,
    files,
    submitLoading,
    submitDisabled,
    onAddFiles,
    onRemoveFile,
    onSubmit,
    goToBack,
  };
};
